angular.module('app.filters').filter('rtmpPushChannelPushSettings', () =>
    function(settings) {
        const url = `${settings.stream_url}/${settings.stream_key}`

        let maxRes = '';
        if (settings.max_resolution) {
            maxRes = ` (limited to ${settings.max_resolution}p)`;
        }

        return `RTMP Push Channel: ${settings.name} (<code>${url}</code>)${maxRes}`;
    }
);


// WEBPACK FOOTER //
// ./filters/rtmp_push_channel_push_settings.js